import React from "react";
import Avatar from "@mui/material/Avatar";
import calculateNameInitial from "../../util/calculateNameInitial";

const MaterialAvatar = (props) => {
    const { user, roleColor, sx, ...otherMuiAvatarProps } = props;
    const nameInitials = calculateNameInitial(user?.name);
    const border = !!roleColor ? `3px solid ${roleColor}` : "none";

    return (
        <Avatar
            sx={{
                width: 35,
                height: 35,
                fontSize: "12px",
                border,
                ...sx,
            }}
            src={user?.photoURL}
            {...otherMuiAvatarProps}
        >
            {nameInitials}
        </Avatar>
    );
};

export default MaterialAvatar;
